export default {
  userClickedFlowtagBackButton: 'userClickedFlowtagBackButton',
  userClickedFlowtagNextButton: 'userClickedFlowtagNextButton',
  userClickedFlowtagAuthenticationButton: 'userClickedFlowtagAuthenticationButton',
  userTypedFlowtagFormInput: 'userTypedFlowtagFormInput',
  userClickedFlowtagFormItem: 'userClickedFlowtagFormItem',
  userClickedFlowtagEducationSlidesPip: 'userClickedFlowtagEducationSlidesPip',
  userSwipedFlowtagEducationSlide: 'userSwipedFlowtagEducationSlide',
  userClickedCopySlugName: 'userClickedCopySlugName',
  userSelectedExistingPage: 'userSelectedExistingPage',
  flowtagActivated: 'flowtagActivated',
  flowtagActivationFailed: 'flowtagActivationFailed',
  Flowtag_Socials_Default_CRM_Added: 'Flowtag_Socials_Default_CRM_Added',
  Flowtag_Onboarding_Selected_Color: 'Flowtag_Onboarding_Selected_Color'
}
